<template>
  <cv-header-menu aria-label="Contabilità" title="Contabilità" :hover-toggle="autoapertura">
    <cv-header-menu-item href="/#/fatture">Maschera Fatture</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-fatture">Ricerca Fatture</cv-header-menu-item>
    <cv-header-menu-item href="/#/generazione-fatture">Gener. fatt. per più lavori</cv-header-menu-item>
    <cv-header-menu-item href="/#/riepilogo-fatture">Riepilogo fatt. per cliente</cv-header-menu-item>
    <hr>
    <cv-header-menu-item href="/#/bilancio">Maschera Bilancio</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-bilancio" >Ricerche Bilancio</cv-header-menu-item>
  </cv-header-menu>
</template>

<script>
export default {
  name: "MenuContabilita",
  props: {
    autoapertura: {
      type: Boolean,
        required: true
      }
    }
}
</script>

<style scoped>
hr {
  width: 11em;
  border-width: thin;
}
</style>